export enum PromotionCodeFields {
  PromoCode = 'promoCode',
}
